import { render, staticRenderFns } from "./SkyBox.vue?vue&type=template&id=3756059b&scoped=true"
import script from "./SkyBox.vue?vue&type=script&lang=js"
export * from "./SkyBox.vue?vue&type=script&lang=js"
import style0 from "./SkyBox.vue?vue&type=style&index=0&id=3756059b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3756059b",
  null
  
)

export default component.exports